export default function clientNeedServiceWorker(client) {
  return ['ocp', 'hub', 'edu'].includes(client);
}
